import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import EditEvent from "./views/EditEvent";
import * as eventsActions from "../../../../redux/modules/events";
import * as optionsActions from "../../../../redux/modules/options";

const mapStateToProps = state => {
  return {
    loading: state.events.loading,
    success: state.events.success,
    saved: state.events.saved,
    message: state.events.message,
    fieldErrors: state.events.formErrors,
    id: state.events.id,
    viewData: state.events.viewData,
    reducerName: "events",

    model: state.options.model,
    baseFields: state.options.baseFields,
    enabledFields: state.options.enabledFields,
    user: state.auth.user
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      create: eventsActions.createEvent,
      updateRight: eventsActions.updateEvent,
      viewRight: eventsActions.viewEvent,
      reset: eventsActions.reset,
      resetForm: eventsActions.resetForm,
      getCustomInfo: optionsActions.getFormInfo
    },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditEvent);
